<template>
  <div>
    <purchases-filter
      @filterSelected="filterSelected"
      :ref="`filters`"
    ></purchases-filter>
    <el-card
      shadow="always"
      style="height: 100%"
      :body-style="{ padding: '0px' }"
    >
      <div class="row bg-water-blue text-dark-blue p-2 text-uppercase">
        <div class="col-12 d-flex align-items-center justify-content-between">
          <h3 class="mb-0">All Ottley Trades</h3>
            <div class="font-weight-bold">
              Total: {{ stats.total ? "$" + $_toLocaleString(stats.total) : 0 }}
              <el-tooltip content="Livestock + Mgmt Fee (inc) as at Today" placement="top">
                <i class="fas fa-info-circle"></i>
              </el-tooltip>
            </div>
        </div>
      </div>
      <div class="row p-2" v-loading="loading">
        <div class="col-12 text-right mb-2">
          <el-input
            class="mr-2"
            size="mini"
            placeholder="Enter to search"
            style="width: 150px"
            v-model="query"
            @change="
              getData();
              getDataStats();
            "
            clearable
          />
          <el-button class="btn-secondary" @click="openFilter"
            >Filter</el-button
          >
        </div>
        <div class="col-12">
          <el-table :data="purchases.data" style="width: 100%">
            <el-table-column prop="id" label="" width="50px">
              <template slot-scope="scope">
                <invoice-button
                  :initial_purchase="scope.row"
                  v-if="scope.row.invoice_collections.length > 0"
                ></invoice-button>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="Trade #" width="80px">
              <template slot-scope="scope">
                {{ scope.row.ref_id }}
                <el-tooltip
                  class="item"
                  v-if="scope.row.has_pending_sale"
                  effect="dark"
                  content="This purchase is pending closure in a future sale"
                  placement="top-start"
                >
                  <i class="fas fa-flag text-warning"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="business.name"
              label="Producer"
              width="300px"
            >
              <template slot-scope="scope">
                <a
                  v-if="scope.row && scope.row.business"
                  :href="`/businesses/${scope.row.business_id}`"
                >
                  {{ scope.row.business.name }}
                </a>
              </template>
            </el-table-column>
            <el-table-column
              prop="reference_code"
              label="Reference"
              width="150px"
            >
            </el-table-column>
            <el-table-column
              prop="number_of_head"
              label="Original Hd"
              width="90px"
            >
            </el-table-column>
            <el-table-column prop="open_head" label="Open Hd" width="80px">
              <template slot-scope="scope">
                {{ scope.row.open_heads ? scope.row.open_heads : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="" label="DOF" width="50px">
              <template slot-scope="scope">
                {{ scope.row.dof }}
              </template>
            </el-table-column>
            <el-table-column prop="livestock_class.name" label="Stock">
            </el-table-column>
            <el-table-column prop="" label="Sales (Pending)">
              <template slot-scope="scope">
                {{
                  scope.row.sales
                    ? `${scope.row.sales.length} (${scope.row.sales.filter((x) => x.sale_status_id != 8).length})`
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="" label="Daily Rate">
              <template slot-scope="scope">
                {{
                  scope.row.channel && scope.row.channel.daily_rate
                    ? $_roundAccurately(scope.row.channel.daily_rate, 4) + "%"
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="" label="Start Date">
              <template slot-scope="scope">
                {{
                  scope.row.invoice_invoice_date
                    ? moment(scope.row.invoice_invoice_date).format(
                        "DD/MM/YYYY",
                      )
                    : "--"
                }}
              </template>
            </el-table-column>
            <el-table-column prop="" label="Contract Balance">
              <template slot="header" slot-scope="scope">
                Balance
                <el-tooltip content="Livestock + Mgmt Fee" placement="bottom">
                  <i class="fas fa-info-circle"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.contract_balance_to_date">
                  {{
                    "$" +
                    $_toLocaleString(
                      scope.row.contract_balance_to_date
                        .contract_balance_inc_gst,
                      2,
                    )
                  }}
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="Balance at expiry">
              <template slot-scope="scope">
                <div v-if="scope.row.latest_balance">
                  {{
                    "$" +
                    $_toLocaleString(
                      scope.row.latest_balance.contract_balance_inc_gst,
                      2,
                    )
                  }}
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_due_date" label="Expiry Date">
              <template slot-scope="scope">
                <div :class="classDueDate(scope.row)" style="width: 75px">
                  {{
                    scope.row.invoice_due_date
                      ? moment(scope.row.invoice_due_date).format("DD/MM/YYYY")
                      : "--"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="155" label="Closeout">
              <template slot-scope="scope">
                <el-dropdown
                  v-if="
                    scope.row.closeouts.length == 0 &&
                    scope.row.purchase_status_id == 8 &&
                    scope.row.open_heads > 0 &&
                    scope.row.invoice_due_date &&
                    getDaysUntilExpiryMT(scope.row.invoice_due_date) > 0
                  "
                  class="p-0"
                  @command="closeoutPurchaseMT($event, scope.row)"
                >
                  <el-button
                    type="primary"
                    size="mini"
                    class="btn-primary"
                    :disabled="closeout_purchase_ids.length >= 1"
                  >
                    Closeout <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="invoiceType.id"
                      v-for="invoiceType in invoiceTypes.filter(
                        (it) =>
                          it.id == 2 ||
                          getDaysUntilExpiryMT(scope.row.invoice_due_date) <=
                            30,
                      )"
                      :key="invoiceType.id"
                    >
                      {{ invoiceType.name }}
                    </el-dropdown-item>
                    <hr
                      class="mx-1 my-1"
                      v-if="
                        getDaysUntilExpiryMT(scope.row.invoice_due_date) <= 30
                      "
                    />
                    <el-dropdown-item
                      command="0"
                      v-if="
                        getDaysUntilExpiryMT(scope.row.invoice_due_date) <= 30
                      "
                      >Get values to refinance</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <div
                  class="text-warning"
                  v-else-if="scope.row.closeouts.length > 0"
                >
                  <a
                    href="#"
                    class="d-block"
                    v-if="scope.row.closeouts[0].sale"
                    @click.prevent="openInvoice(scope.row.closeouts[0].sale_id)"
                  >
                    {{ scope.row.closeouts[0].sale.ref_id }}
                  </a>
                  <a
                    href="#"
                    class="d-block"
                    v-if="scope.row.closeouts[0].off_pic_sale"
                    @click.prevent="
                      openInvoice(scope.row.closeouts[0].off_pic_sale_id)
                    "
                  >
                    {{ scope.row.closeouts[0].off_pic_sale.ref_id }}
                  </a>
                </div>
                <div
                  class="text-danger"
                  v-else-if="
                    getDaysUntilExpiryMT(scope.row.invoice_due_date) <= 0 &&
                    scope.row.purchase_status_id == 8 &&
                    scope.row.open_heads > 0
                  "
                >
                  Expired
                </div>
                <div class="text-warning" v-else>No Applicable</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          class="col-12 py-3 d-flex justify-content-center justify-content-xl-end"
        >
          <el-pagination
            layout="prev, pager, next, total"
            :current-page.sync="currentPage"
            @current-change="getData()"
            @prev-click="handlePrev"
            @next-click="handleNext"
            prev-text="Prev"
            next-text="Next"
            :background="true"
            :page-size="perPage"
            :page-count="purchases.last_page"
            :total="purchases.total"
          />
        </div>
      </div>
    </el-card>
    <payout-closeout-modal
      v-if="payoutModalShow"
      :closeout_purchases="closeout_purchases"
      :animals_sold="animals_sold"
      :closeout_livestock_class_id="closeout_livestock_class_id"
      :closeout_business="closeout_business"
      @close="closeModalMT"
      @refresh="refresh"
    ></payout-closeout-modal>
    <refinance-closeout-modal
      v-if="refinanceModalShow"
      :closeout_purchases="closeout_purchases"
      :closeout_livestock_class_id="closeout_livestock_class_id"
      :closeout_business="closeout_business"
      @close="closeModalMT"
      @refresh="refresh"
    ></refinance-closeout-modal>
    <values-to-refinance-closeout-modal
      v-if="valuesToRefinanceModalShow"
      :closeout_purchases="closeout_purchases"
      :closeout_livestock_class_id="closeout_livestock_class_id"
      :closeout_business="closeout_business"
      @close="closeModalMT"
    ></values-to-refinance-closeout-modal>
  </div>
</template>
<script>
import MaxTerm from "../../../mixins/MaxTerm";
import OttleyFormatter from "../../../mixins/OttleyFormatter";
import Purchase from "../../modelsPortal/Purchase";
import Sale from "../../modelsPortal/Sale";
import PurchasesFilter from "./components/PurchasesFilter.vue";
import InvoiceType from "../../modelsPortal/InvoiceType";
import PayoutCloseoutModal from "../../../common/PayoutCloseoutModal.vue";
import RefinanceCloseoutModal from "../../../common/RefinanceCloseoutModal.vue";
import ValuesToRefinanceCloseoutModal from "../../../common/ValuesToRefinanceCloseoutModal.vue";
export default {
  components: {
    PurchasesFilter,
    PayoutCloseoutModal,
    RefinanceCloseoutModal,
    ValuesToRefinanceCloseoutModal,
  },
  mixins: [OttleyFormatter, MaxTerm],
  props: {},
  mounted() {},
  data() {
    return {
      loading: false,
      purchases: [],
      query: "",
      perPage: 50,
      currentPage: 1,
      filter: {
        status_ids: "1",
      },
      query: "",
      stats: { total: 0 },
      invoiceTypes: [],
    };
  },
  mounted() {
    this.getData();
    this.getDataStats();
    this.getInvoiceTypes();
  },
  methods: {
    refresh() {
      this.refreshMT();
      this.getData();
    },
    openInvoice(saleId) {
      new Sale()
        .find(saleId)
        .then((result) => {
          let sale = result;
          if (sale.invoice_html_url) {
            window.open(sale.invoice_html_url);
          } else {
            this.$message({
              type: "warning",
              message: "We are unable to open this link. Please try later",
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    getInvoiceTypes() {
      new InvoiceType()
        .whereIn("id", [1, 2])
        .get()
        .then((result) => {
          this.invoiceTypes = result;
        })
        .catch((err) => {});
    },
    classDueDate(purchase) {
      if (!purchase.reconciled_at) {
        if (moment(purchase.invoice_due_date).diff(moment(), "days") < 0)
          return "badge badge-danger p-1 text-white";
        else if (
          moment(purchase.invoice_due_date).diff(
            moment().add(1, "months"),
            "days",
          ) < 0
        )
          return "badge badge-warning bg_red_purchases p-1 text-white";
      }
      return "text-center p-1";
    },
    openFilter() {
      this.$root.$emit("openFilter");
    },
    filterSelected(filter) {
      if (filter) {
        this.filter = filter;
      }
      this.getData();
      this.getDataStats();
    },
    getDataStats() {
      let data = {
        no_paginate: true,
        fields: "id,value",
        append: "latest_balance,has_pending_sale",
      };

      if (this.query) {
        data["filter[where_like]"] = this.query;
      }

      if (this.filter) {
        if (this.filter.business_ids) {
          data["filter[business_id]"] = this.filter.business_ids.split(",");
        }

        if (this.filter.stock_ids) {
          data["filter[livestock_class_id]"] = this.filter.stock_ids.split(",");
        }
        if (this.filter.status_ids) {
          data["filter[open_closed]"] = this.filter.status_ids.split(",");
        }
        if (this.filter.due_date) {
          data["filter[invoice_due_date_between]"] =
            this.filter.due_date.join(",");
        }
        if (this.filter.start_date) {
          data["filter[bill_invoice_date_between]"] =
            this.filter.start_date.join(",");
        }
        if (this.filter.expiry_id) {
          data["filter[expiry_date_filter]"] = this.filter.expiry_id;
        }
        if (this.filter.dof) {
          data["filter[days_of_feed_filter]"] = this.filter.dof.split(",");
        }
      }

      axios
        .get(`/api/v2/portal/purchases/stats`, {
          params: data,
        })
        .then((res) => {
          this.stats = res.data;
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    async getData() {
      this.loading = true;

      let purchases = new Purchase()
        .select({
          business: ["id", "name"],
          purchases: [
            "id",
            "ref_id",
            "reference_code",
            "invoice_due_date",
            "invoice_invoice_date",
            "purchase_status_id",
            "business_id",
            "number_of_head",
            "open_head",
            "livestock_class_id",
            "channel_id",
            "reconciled_at",
          ],
          livestockClass: ["id", "name"],
          channel: ["id", "rate"],
          closeouts: ["id", "purchase_id", "sale_id", "off_pic_sale_id"],
          "closeouts.sale": ["id", "ref_id"],
          "closeouts.offPicSale": ["id", "ref_id"],
        })
        .append(
          "latest_balance",
          "dof",
          "contract_balance_to_date",
          "open_heads",
        )
        .include(
          "business",
          "purchaseStatus",
          "channel",
          "livestockClass",
          "sales",
          "purchaseAssetsOpened",
          "closeouts.sale",
          "closeouts.offPicSale",
          "invoiceCollections",
        );

      if (this.orderBy) {
        purchases.orderBy(this.orderBy);
      } else {
        purchases.orderBy("invoice_due_date");
      }

      if (this.query) {
        purchases.where("where_like", this.query);
      }

      if (this.filter) {
        if (this.filter.business_ids) {
          purchases.whereIn("business_id", this.filter.business_ids.split(","));
        }
        if (this.filter.purchase_status_ids) {
          purchases.whereIn(
            "purchase_status_id",
            this.filter.purchase_status_ids.split(","),
          );
        }
        if (this.filter.stock_ids) {
          purchases.whereIn(
            "livestock_class_id",
            this.filter.stock_ids.split(","),
          );
        }
        if (this.filter.status_ids) {
          purchases.whereIn("open_closed", this.filter.status_ids.split(","));
        }
        if (this.filter.due_date) {
          purchases.where(
            "invoice_due_date_between",
            this.filter.due_date.join(","),
          );
        }
        if (this.filter.start_date) {
          purchases.where(
            "bill_invoice_date_between",
            this.filter.start_date.join(","),
          );
        }
        if (this.filter.warehouse_ids) {
          purchases.whereIn(
            "warehouse_id",
            this.filter.warehouse_ids.split(","),
          );
        }
        if (this.filter.expiry_id) {
          purchases.where("expiry_date_filter", this.filter.expiry_id);
        }
        if (this.filter.dof) {
          purchases.whereIn("days_of_feed_filter", this.filter.dof.split(","));
        }
      }

      purchases.page(this.currentPage).params({
        per_page: this.perPage,
        asset_off_pic: true,
        closeouts_count: true,
      });

      await purchases
        .get()
        .then((res) => {
          this.purchases = res;
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    handleNext() {
      this.currentPage++;
    },
    handlePrev() {
      this.currentPage > 1 && this.currentPage--;
    },
  },
};
</script>
<style>
.bg_red_purchases {
  background-color: #f86c6b8a !important;
}
</style>
